import styled from 'styled-components';
import { hideDefaultThumbnail } from '../styles';

const PlayButtonPopoverContainer = styled.div`
  position: relative;
  display: inline-block;
  height: 100px;
  width: 100px;
  position: relative;
  ${hideDefaultThumbnail}
`;

export { PlayButtonPopoverContainer };
